/**
 * Formats an ISO datetime string to local datetime format using device's locale and timezone
 * @param {string} isoString - ISO datetime string
 * @returns {string} Formatted local datetime
 */
export const formatLocalDateTime = (isoString) => {
    if (!isoString) return "N/A";

    try {
        const date = new Date(isoString);
        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    } catch (error) {
        return isoString;
    }
};
